export default __webpack_public_path__ + "d59d5b781d93185a079b10cd8ec7b815.png";